/*
 * @Author: 40463 jia.rong.li@hand-china.com
 * @Date: 2024-12-16 11:44:39
 * @LastEditors: 40463 jia.rong.li@hand-china.com
 * @LastEditTime: 2025-01-05 10:10:50
 * @FilePath: \dq-wxpa\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/HelloFromVux'
import Detail from '../views/detail.vue'
import ReservationHome from '../views/AppointmentFormManagement/home.vue'
import ReservationDetail from '../views/AppointmentFormManagement/detail.vue'

Vue.use(VueRouter)

// 获取 openId 的方法（假设你已经有此方法）
// const getOpenId = () => {
//   return localStorage.getItem('openId') || null;  // 从 localStorage 中获取 openId
// }

const routes = [
  {
    path: '/',
    redirect: '/reservation/home',  // 默认访问路径
  },
  {
    path: '/reservation/home',
    component: Home
  },
  {
    path: '/reservation/detail',
    component: Detail
  },
  {
    path: '/appointment-form-management/home',
    component: ReservationHome
  },
  {
    path: '/appointment-form-management/detail/:reservationDocId',
    component: ReservationDetail
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
// router.beforeEach((to, from, next) => {
//   const openId = getOpenId();  // 获取 openId

//   // 判断是否已获得 openId
//   if (!openId && to.path !== '/reservation/home') {
//     // 如果没有 openId 且当前访问的不是首页，跳转到授权页面
//     // 你可以在此处跳转到微信授权页面
//     // 例如：window.location.href = '微信授权链接';
//     alert('用户尚未授权，跳转到授权页面');
//     next('/reservation/home');  // 跳转到首页进行授权
//   } else {
//     // 如果已获取 openId 或访问的是首页，正常跳转
//     next();
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js